import React, { memo } from "react";
import { Text, TouchableOpacity, StyleSheet, Platform } from "react-native";

import appStyles from "../../../appStyles";
import ManaIcon from "../../common/icons/ManaIcon";

const PredictionMore = ({ onPress }) => {
  return (
    <TouchableOpacity
      onPress={onPress}
      style={[appStyles.row, styles.morePill]}
    >
      {/*<ManaIcon width={20} height={20} style={styles.moreIcon} />*/}
      <Text style={styles.moreText}>More...</Text>
    </TouchableOpacity>
  );
};

export default memo(PredictionMore);

const styles = StyleSheet.create({
  morePill: {
    backgroundColor: "#F4F6FA",
    height: 34,
    maxWidth: "100%",
    paddingVertical: 2,
    paddingHorizontal: 10,
    borderRadius: 30,
    minWidth: 112,
  },
  moreIcon: {
    width: 20,
    height: 20,
    marginRight: 5,
  },
  moreText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "300",
    fontSize: 12,
    lineHeight: 14,
    letterSpacing: 0.5,
    color: "#2D3142",
  },
});
